<template>
    <div class="vue-slider" v-if="showSlider" ref="sliderOuterDom">
        <ul class="vue-slider-ul" ref="sliderListDom">
            <li class="vue-slider-ul-li" v-for="(item, index) in scrollList">
                <div @click="gotoLink(item.linkUrl, item)">
                    <img :data-src="item.imgUrl" src="" class="vue-slider-ul-li-img" v-show="initedList">
                </div>
            </li>
        </ul>
    </div>
</template>

<script>

  import './scss/scrollList.scss'

  function addClass(obj, cls) {
    if (hasClass(obj, cls)) {
      return false
    }
    var obj_class = obj.className//获取 class 内容.
    var blank = (obj_class != '') ? ' ' : ''//判断获取到的 class 是否为空, 如果不为空在前面加个'空格'.
    var added = obj_class + blank + cls//组合原来的 class 和需要添加的 class.
    obj.className = added//替换原来的 class.
  }

  function removeClass(obj, cls) {
    if (!hasClass(obj, cls)) {
      return false
    }
    var obj_class = ' ' + obj.className + ' '//获取 class 内容, 并在首尾各加一个空格. ex) 'abc        bcd' -> ' abc        bcd '
    obj_class = obj_class.replace(/(\s+)/gi, ' ')//将多余的空字符替换成一个空格. ex) ' abc        bcd ' -> ' abc bcd '
    var removed = obj_class.replace(' ' + cls + ' ', ' ')//在原来的 class 替换掉首尾加了空格的 class. ex) ' abc bcd ' -> 'bcd '
    removed = removed.replace(/(^\s+)|(\s+$)/g, '')//去掉首尾空格. ex) 'bcd ' -> 'bcd'
    obj.className = removed//替换原来的 class.
  }

  function hasClass(obj, cls) {
    var obj_class = obj.className//获取 class 内容.
    var obj_class_lst = obj_class.split(/\s+/)//通过split空字符将cls转换成数组.
    var x = 0
    for (x in obj_class_lst) {
      if (obj_class_lst[x] == cls) {//循环数组, 判断是否包含cls
        return true
      }
    }
    return false
  }

  function getSiblings(el, filter) {
    var siblings = []
    el = el.parentNode.firstChild
    do {
      if (!filter || filter(el)) siblings.push(el)
    } while (el = el.nextSibling)
    return siblings
  }

  /**
   *
   */
  class ScrollList {
    constructor(_options) {
      this.touchStatus = {
        startX: 0,
        moveX: 0,
        endX: 0
      }
      this.scrollLenth = 0
      this.currScrollIndex = 1
      this.autoPlay = (typeof _options.autoPlay) != 'undefined' ? Boolean(_options.autoPlay) : true
      this.speed = _options.speed ? _options.speed : 2500
      this.sliderOuterDom = _options.sliderOuterDom
      this.sliderListDom = _options.sliderListDom
      this.slideIndexDom = null

      this.slideItems = Array.prototype.slice.call(this.sliderListDom.getElementsByTagName('li'))
      this.slideItemLength = this.slideItems.length
      this.scrllWinWidth = this.getStyle(this.sliderOuterDom, 'width')
      this.autoPlayInterval = 0
      this.autoPlaying = false

      if (!this.sliderOuterDom) {
        console.error('初始化dom失败')
      }
      this.afterInit = _options.afterInit ? _options.afterInit : function() {
      }
      this.initStyle()
      this.initEvent()
      this._initSliderIndex()
      if (this.autoPlay) {
        this._startAutoPlay()
      }
      this.afterInit()
      window.addEventListener('resize', (e) => {
        setTimeout(() => {
          this.scrllWinWidth =this.getStyle(this.sliderOuterDom, 'width');
          this.refresh()
        }, 100)
      })
    }

    initStyle() {
      this.setCSS(this.sliderListDom, { 'width': this.scrllWinWidth * this.slideItemLength + 'px' })
      this.slideItems.forEach(item => {
        this.setCSS(item, { 'width': this.scrllWinWidth + 'px' })
      })
    }

    initEvent() {

      this.sliderOuterDom.addEventListener('touchstart', (e) => {
        if (this.autoPlay) {
          this._stopAutoPlay()
        }
//                console.log(e.touches[0].pageX)
        this.touchStatus.startX = e.touches[0].pageX
        this.touchStatus.moveX = e.touches[0].pageX
      })
      this.sliderOuterDom.addEventListener('touchmove', (e) => {
        var moveX = e.touches[0].pageX - this.touchStatus.moveX
        this.setCSS(this.sliderListDom, { 'transform': 'translate3d(' + (this.scrollLenth + moveX) + 'px,0,0)' })
        this.scrollLenth = this.scrollLenth + moveX
//                console.log((this.scrollLenth+moveX)+"====move");
        this.touchStatus.moveX = e.touches[0].pageX
      })
      this.sliderOuterDom.addEventListener('touchend', (e) => {
        if (this.touchStatus.moveX - this.touchStatus.startX > 0) { //从左向右移动
          if (this.currScrollIndex == 1) {
            this.scrollTo(1)
            this.currScrollIndex = 1
          } else {
            this.scrollTo(--this.currScrollIndex)
          }
        } else if (this.touchStatus.moveX - this.touchStatus.startX < 0) { //从右往左移动
          if (this.currScrollIndex == this.slideItemLength) {
            this.scrollTo(this.slideItemLength)
            this.currScrollIndex = this.slideItemLength
          } else {
            this.scrollTo(++this.currScrollIndex)
          }
        }
        if (this.autoPlay) {
          this._startAutoPlay()
        }

        this.touchStatus.startX = 0
        this.touchStatus.moveX = 0

      })
    }

    _initSliderIndex() {
      if (!this.slideIndexDom) {
        let slideIndexOuter = document.createElement('UL')
        slideIndexOuter.setAttribute('class', 'vue-slider-index')
        this.slideIndexDom = slideIndexOuter
        this.sliderOuterDom.appendChild(slideIndexOuter)
      }
      let slideInerHtml = ''
      this.slideItems.forEach(item => {
        slideInerHtml += '<li class="vue-slider-index-li"></li>'
      })
      this.slideIndexDom.innerHTML = slideInerHtml

      let indexItems = Array.prototype.slice.call(this.slideIndexDom.getElementsByTagName('li'))
      let $this = this
//            console.log("indexItems===",indexItems,indexItems.length)
      indexItems.forEach((item, index) => {
        item.onclick = () => {
          $this.scrollTo(index + 1)
        }
      })
      $this._focusIndex(0)

    }

    _focusIndex(_index) {
      let items = Array.prototype.slice.call(this.slideIndexDom.getElementsByTagName('li'))
      items.forEach((item, index) => {
        if (index == _index) {
          addClass(item, 'on')
        } else {
          removeClass(item, 'on')
        }
      })

    }

    _startAutoPlay() {
//            console.log("start interval ...");
      if (this.slideItemLength == 1 || this.autoPlaying) {
        return false
      }
      this.autoPlaying = true
      this.autoPlayInterval = setInterval(() => {
        this._doAutoPlay()
      }, this.speed)
    }

    _stopAutoPlay() {
//            console.log("stop interval ...");
      clearInterval(this.autoPlayInterval)
      this.autoPlaying = false
    }

    _doAutoPlay() {
      if (this.currScrollIndex == this.slideItemLength) {
        this.scrollTo(1)
        this.currScrollIndex = 1
      } else {
        this.scrollTo(++this.currScrollIndex)
      }
    }

    scrollTo(_index) {
//            console.log("scrollIndex "+_index);
      this.setCSS(this.sliderListDom, { 'transform': 'translate3d(-' + (this.scrllWinWidth * (_index - 1)) + 'px,0,0)' })
      this.scrollLenth = -this.scrllWinWidth * (_index - 1)
      this._focusIndex(_index - 1)
    }


    /**
     * 动态增加子菜单列表
     */
    refresh() {
      this.slideItems = Array.prototype.slice.call(this.sliderListDom.getElementsByTagName('li'))
      this.slideItemLength = this.slideItems.length
      this.initStyle()
      this.initEvent()
      this._initSliderIndex()
    }

    setCSS(_dom, styles) {
      for (let key in styles) {
        _dom.style[key] = styles[key]
      }
    }

    getStyle(_dom, key) {
      var result = getComputedStyle(_dom)[key]
      return parseFloat(result)
    }
  }

  import axios from '~/plugins/axios'

  export default {
    props: ['scrollList', 'picPrePath'],
    data() {
      return {
        showSlider: true,
        srollList: null,
        inited: false,
        initedList: false
      }
    },

    mounted() {

    },
    methods: {
      initDataSrc() {
        let imgItems = Array.prototype.slice.call(this.$refs.sliderListDom.getElementsByTagName('img'))
        imgItems.forEach((item) => {
          console.log('item...', item.getAttribute('data-src'))
          item.setAttribute('src', item.getAttribute('data-src'))
        })
      },
      initScrollList() {
        let $this = this
        if (this.inited) {
          this.srollList.refresh()
        } else {
          this.inited = true
          this.initedList = false
          this.srollList = new ScrollList({
            sliderOuterDom: this.$refs.sliderOuterDom,
            sliderListDom: this.$refs.sliderListDom,
            afterInit: function() {
//                            console.log("after init",this);
              this.initedList = true
            }.bind(this)
          })
        }
      },
      gotoIndex(_index) {
        console.log('index === ', _index)
      },
      gotoLink(_linkUrl, _item) {
        //update go link
        axios.post('https://ban.zhoubao.me/api/statistics', {
            'buttonId': _item['_id'],
            'eventType': 'bannerClick'
          }
        )
          .then(function(response) {
            console.log(response)
            location.href = _linkUrl
          })
          .catch(function(error) {
            console.log(error)
            location.href = _linkUrl
          })

      }

    },
    watch: {
      scrollList: function() {
        this.$nextTick(() => {
          this.initDataSrc()
          this.initScrollList()
        })
      }
    }
  }
</script>




// WEBPACK FOOTER //
// components/ScrollList.vue